'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _Page = require('components/Page/Page');

var _Page2 = _interopRequireDefault(_Page);

var _StatisticsTabs = require('components/Statistics/StatisticsTabs/StatisticsTabs');

var _StatisticsTabs2 = _interopRequireDefault(_StatisticsTabs);

var _StatisticsPeriod = require('components/Statistics/StatisticsPeriod/StatisticsPeriod');

var _StatisticsPeriod2 = _interopRequireDefault(_StatisticsPeriod);

var _StatisticsDatePicker = require('containers/Statistics/StatisticsDatePicker/StatisticsDatePicker');

var _StatisticsDatePicker2 = _interopRequireDefault(_StatisticsDatePicker);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('helpers/statistics');

var _datetime = require('helpers/datetime');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Statistics.scss');

var Statistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;
    var _getState$statistics = getState().statistics,
        startDate = _getState$statistics.startDate,
        endDate = _getState$statistics.endDate;

    if (!startDate || !endDate) {
      dispatch(statisticsActions.setPeriod({ periodName: _statistics2.reportPeriods.week }));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    endDate: state.statistics.endDate,
    startDate: state.statistics.startDate,
    periodName: state.statistics.periodName,
    projectId: state.statistics.projectId,
    recipientId: state.statistics.recipientId
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Statistics, _Component);

  function Statistics() {
    (0, _classCallCheck3.default)(this, Statistics);
    return (0, _possibleConstructorReturn3.default)(this, (Statistics.__proto__ || (0, _getPrototypeOf2.default)(Statistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(Statistics, [{
    key: 'setReportDates',
    value: function setReportDates(_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      this.props.setReportDates({ startDate: (0, _datetime.formatDateToSql)(startDate), endDate: (0, _datetime.formatDateToSql)(endDate) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          component = _props.component,
          startDate = _props.startDate,
          endDate = _props.endDate,
          periodName = _props.periodName,
          projectId = _props.projectId,
          recipientId = _props.recipientId;
      var t = this.context.t;


      return _react2.default.createElement(
        _Page2.default,
        {
          className: styles.page,
          header: t('Statistics'),
          title: t('Statistics'),
          pullHeaderLeft: true
        },
        _react2.default.createElement(_StatisticsTabs2.default, {
          className: 'margin-bottom-10',
          projectId: projectId,
          recipientId: recipientId
        }),
        _react2.default.createElement(
          'div',
          { className: styles.periodLine },
          _react2.default.createElement(_StatisticsPeriod2.default, null),
          _react2.default.createElement(_StatisticsDatePicker2.default, {
            onChange: this.setReportDates,
            onClose: this.setReportDates,
            endDate: endDate,
            startDate: startDate,
            hidden: periodName !== _statistics2.reportPeriods.custom
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'clear' },
          component
        )
      );
    }
  }]);
  return Statistics;
}(_react.Component), _class3.propTypes = {
  component: _propTypes2.default.node,
  endDate: _propTypes2.default.string,
  periodName: _propTypes2.default.string,
  projectId: _propTypes2.default.number,
  recipientId: _propTypes2.default.number,
  setReportDates: _propTypes2.default.func,
  startDate: _propTypes2.default.string
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  setReportDates: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setReportDates', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportDates'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = Statistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/Statistics.js
// module id = 2218
// module chunks = 1